import { useLocalizedFields } from "@/shared/form/localized-value/model/localized-field";
import useFormInstance from "antd/es/form/hooks/useFormInstance";

export function useCopingToOtherLanguages(
  name: string | string[],
  activeLanguage?: string,
) {
  const { getFieldValue, setFieldValue } = useFormInstance();
  const { languages, localeToControlName } = useLocalizedFields();

  const copy = () => {
    const activePath = [
      ...(Array.isArray(name) ? name : [name]),
      "templateData",
      activeLanguage,
    ];
    const activeValue = getFieldValue(activePath);

    languages.forEach((locale) => {
      const targetPath = [
        ...(Array.isArray(name) ? name : [name]),
        "templateData",
        localeToControlName(locale),
      ];

      setFieldValue(targetPath, activeValue);
    });
  };

  return {
    copy,
  };
}
